import {CustomPreviewProps} from '@domain/kiln-monitoring'
import {useUpmPlant} from '@hconnect/upm'

import {KilnShellDrawing} from './KilnShellDrawing'
import {getKilnMaterialInstallationsWithColor} from './utils'

import {useRefractoryCustomizationsQuery} from '@refra/modules/common/hooks/queries/customizations'
import {useKilns} from '@refra/modules/common/providers'
import {useKilnMaterialInstallationsQuery} from '@refra/modules/refra-planning/hooks/queries/useKilnMaterialInstallationsQuery'
import {MaterialInstallation} from '@refra/modules/refra-planning/types'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const KilnShellSvg = ({width, meterToPixel, kilnLength}: CustomPreviewProps) => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})

  const {selectedKiln} = useKilns()
  const {data: kilnMaterialInstallations} = useKilnMaterialInstallationsQuery({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId
  })

  const assignedRefractoriesIds = new Set(kilnMaterialInstallations?.map((mi) => mi.refractoryId))
  const isRefractoriesQueryEnabled = assignedRefractoriesIds.size > 0

  const {data: assignedRefractoriesPaginated} = useRefractoryCustomizationsQuery({
    plantUpmId: upmPlant.upmId,
    ids: [...assignedRefractoriesIds],
    enabled: isRefractoriesQueryEnabled
  })
  const refractories = assignedRefractoriesPaginated?.refractories ?? []

  const isKilnShellSvgLoading =
    !meterToPixel ||
    !kilnMaterialInstallations ||
    (isRefractoriesQueryEnabled && !assignedRefractoriesPaginated)

  if (isKilnShellSvgLoading) return null

  const kilnMaterialInstallationsWithColor =
    getKilnMaterialInstallationsWithColor<MaterialInstallation>(
      kilnMaterialInstallations,
      kilnLength ?? width
    )

  const materialInstallations = kilnMaterialInstallationsWithColor.map((materialInstallation) => {
    const refractory = refractories.find((rf) => rf.id === materialInstallation.refractoryId)

    const refractoryGlobalColor = refractory?.color ?? materialInstallation.color
    const refractoryLocalColor =
      refractory?.customization?.color ?? refractoryGlobalColor ?? materialInstallation.color

    return {
      ...materialInstallation,
      globalColor: refractoryGlobalColor,
      localColor: refractoryLocalColor,
      refractoryName: refractory?.name ?? '',
      manufacturerName: refractory?.manufacturer.name ?? '',
      comments: []
    }
  })

  return (
    <KilnShellDrawing
      meterToPixel={meterToPixel}
      kilnLength={kilnLength}
      materialInstallations={materialInstallations}
    />
  )
}
